/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AgreementTypeFromJSON, AgreementTypeToJSON, CarDtoFromJSON, CarDtoToJSON, CarModelDtoFromJSON, CarModelDtoToJSON, CustomerIdDtoFromJSON, CustomerIdDtoToJSON, ReservationBasicDtoFromJSON, ReservationBasicDtoToJSON, } from './';
export function AgreementDtoFromJSON(json) {
    return AgreementDtoFromJSONTyped(json, false);
}
export function AgreementDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'agreementId': !exists(json, 'agreementId') ? undefined : json['agreementId'],
        'agreementNumber': !exists(json, 'agreementNumber') ? undefined : json['agreementNumber'],
        'customer': !exists(json, 'customer') ? undefined : CustomerIdDtoFromJSON(json['customer']),
        'begins': !exists(json, 'begins') ? undefined : (new Date(json['begins'])),
        'ends': !exists(json, 'ends') ? undefined : (new Date(json['ends'])),
        'type': !exists(json, 'type') ? undefined : AgreementTypeFromJSON(json['type']),
        'car': !exists(json, 'car') ? undefined : CarDtoFromJSON(json['car']),
        'carModels': !exists(json, 'carModels') ? undefined : (json['carModels'] === null ? null : json['carModels'].map(CarModelDtoFromJSON)),
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'reservations': !exists(json, 'reservations') ? undefined : (json['reservations'] === null ? null : json['reservations'].map(ReservationBasicDtoFromJSON)),
    };
}
export function AgreementDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'agreementId': value.agreementId,
        'agreementNumber': value.agreementNumber,
        'customer': CustomerIdDtoToJSON(value.customer),
        'begins': value.begins === undefined ? undefined : (value.begins.toISOString()),
        'ends': value.ends === undefined ? undefined : (value.ends.toISOString()),
        'type': AgreementTypeToJSON(value.type),
        'car': CarDtoToJSON(value.car),
        'carModels': value.carModels === undefined ? undefined : (value.carModels === null ? null : value.carModels.map(CarModelDtoToJSON)),
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'reservations': value.reservations === undefined ? undefined : (value.reservations === null ? null : value.reservations.map(ReservationBasicDtoToJSON)),
    };
}
